module.exports = __webpack_public_path__ + "img/edit.4f36f6dd.svg";